<div class="ui-control ui-inline-control" [formGroup]="formGroup">
  <span class="input-label">{{inputData.label}}</span>
  <textarea class="input-control" pInputTextarea [formControlName]="inputData.colName"></textarea>
</div>


<!-- Visible on group -->
<!-- Disabled on input -->
<!-- Display name on label -->
<!-- Is required -->